import type {AddClientNoteFormPayload} from "./add-client-note.schema";

import {addClientNote} from "@project/sdk/sales";
import {AddClientNoteBody} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";

import {clientKeys, clientMutationKeys} from "../../../../../client-keys";

export function addClientNoteMutationOptions(clientId: string) {
  return mutationOptions({
    mutationFn: (payload: AddClientNoteFormPayload) =>
      addClientNote(clientId, AddClientNoteBody.parse(payload)),
    mutationKey: clientMutationKeys.addClientNote,
    onSuccess: async (_noteId, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: clientKeys.detail(clientId)}),
        client.invalidateQueries({queryKey: clientKeys.lists()}),
      ]);
    },
  });
}
